/**
 * Theme constants for SendConfig component
 * Centralizes colors, sizes, and styling values
 */

export const SEND_CONFIG_THEME = {
    colors: {
        primary: "#086AA9",
        primaryHover: "#064f7a",
        warning: "#BF1F1F",
        errorText: "#BF1F1F",
        textPrimary: "gray.700",
        textSecondary: "gray.600",
        trackBg: "gray.200",
    },
    slider: {
        thumbSize: 5,
        borderWidth: "2px",
        trackHeight: "4px",
    },
    spacing: {
        sliderPaddingBottom: 8,
        sliderPaddingX: 2,
    },
    fontSize: {
        title: "14px",
        subtitle: "12px",
        mark: "sm",
        tooltip: "xs",
    },
} as const;
